const { createEventGA4 } = require('./eventGA4');

/**
 * @typedef {object} AbstractEcommerceEventGA4
 * @property {object} dl_ga4_ecommerce Ecommerce trigger variable
 * @property {string} currency Currency of the site
 * @property {string} value Value of the product
 * @property {Array} items Array of objects that contains all extra info
 */

/**
 * Ecommerce Event for Google Analytics 4.
 * It contains general variables and dl_ga4_ecommerce.
 * @typedef {import('./eventGA4').EventGA4 & AbstractEcommerceEventGA4} EcommerceEventGA4
 */

/**
 *
 * @param {string} name The name of the event
 * @param {EcommerceItems} items The items of the event
 * @param {Object} ecommerceProps The props needed for a specific ecommerce event
 * @param {Object} [additionalProps] Additional props if exists
 * @returns {EcommerceEventGA4} object with all the params that are needed
 */
function createEcommerceEventGA4(
  name,
  items,
  ecommerceProps,
  additionalProps = {}
) {
  return createEventGA4('eventga4_ecommerce', name, {
    dl_ga4_ecommerce: {
      ...ecommerceProps,
      items,
    },
    ...(additionalProps || {}),
  });
}

module.exports = {
  createEcommerceEventGA4,
};
